import './SkeletonBox-cde41765.css';

var classes = {"SkeletonBox":"prc-Skeleton-SkeletonBox-nSZk3","shimmer":"prc-Skeleton-shimmer-DB3-6"};

export { classes as default };
